module.exports = __webpack_public_path__ + "img/4.efa2ad79.png";